"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _commonReact = require("@devsta/common-react");

var _Reporting = _interopRequireDefault(require("../components/Reporting"));

var _api = require("../../EditOrganisation/api");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Reporting() {
  return _react.default.createElement(_commonReact.RequestProvider, {
    requests: {
      getOrganisations: (0, _api.getOrganisationsApi)()
    }
  }, function (requests) {
    return _react.default.createElement(_Reporting.default, requests);
  });
}

var _default = Reporting;
exports.default = _default;